import { lazy, Suspense } from 'react';
import { Loader } from '@/shared/ui';
import type { Props } from './TreeDataGrid';

const TreeDataGrid = lazy(() =>
  import('./TreeDataGrid').then(({ TreeDataGrid }) => ({
    default: TreeDataGrid,
  })),
);

export function TreeDataGridLazy(props: Props) {
  return (
    <Suspense fallback={<Loader active />}>
      <TreeDataGrid {...props} />
    </Suspense>
  );
}
